import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressRing = ({ 
  percentage = 0, 
  size = 120, 
  strokeWidth = 8, 
  showLabel = true,
  className = ''
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const strokeDasharray = circumference;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  const getProgressColor = (percent) => {
    if (percent >= 80) return 'text-success';
    if (percent >= 50) return 'text-warning';
    if (percent >= 25) return 'text-secondary';
    return 'text-primary';
  };

  const getProgressMessage = (percent) => {
    if (percent === 0) return 'Ready to start';
    if (percent < 25) return 'Getting started';
    if (percent < 50) return 'Making progress';
    if (percent < 75) return 'Well underway';
    if (percent < 100) return 'Almost complete';
    return 'Completed!';
  };

  return (
    <div className={`flex flex-col items-center space-y-4 ${className}`}>
      <div className="relative">
        <svg 
          width={size} 
          height={size} 
          className="transform -rotate-90"
          viewBox={`0 0 ${size} ${size}`}
        >
          {/* Background circle */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke="currentColor"
            strokeWidth={strokeWidth}
            fill="transparent"
            className="text-muted"
          />
          {/* Progress circle */}
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke="currentColor"
            strokeWidth={strokeWidth}
            fill="transparent"
            strokeDasharray={strokeDasharray}
            strokeDashoffset={strokeDashoffset}
            className={`${getProgressColor(percentage)} transition-all duration-500 ease-in-out`}
            strokeLinecap="round"
          />
        </svg>
        
        {/* Center content */}
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <div className="text-center">
            <div className="text-3xl font-bold font-mono text-foreground drop-shadow-sm">
              {Math.round(percentage)}%
            </div>
            <div className="text-sm font-medium text-foreground/80 mt-1">
              Complete
            </div>
          </div>
        </div>
      </div>

      {showLabel && (
        <div className="text-center space-y-2">
          <div className="text-base font-semibold text-foreground">
            Plan Progress
          </div>
          <div className="text-sm text-foreground/80">
            {getProgressMessage(percentage)}
          </div>
          {percentage > 0 && (
            <div className="flex items-center justify-center space-x-1 text-sm font-medium text-green-600 dark:text-green-400">
              <Icon name="CheckCircle" size={14} />
              <span>On track</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ProgressRing;